import { Injectable } from '@angular/core';
import { AppCollection } from '../../../app.config';
import { BaseCollectionService } from '../../jsonApi/BaseCollectionService';
import { SchoolClassJsonModel } from './school-class.json.model';

@Injectable({
  providedIn: 'root'
})
export class SchoolClassService extends BaseCollectionService<SchoolClassJsonModel, AppCollection> {
  protected ctor = SchoolClassJsonModel;
}
